export default __webpack_public_path__ + "static/media/Honour.208ec47d.svg";